import React from 'react';
import urlBase from '../../url-base';
import {
    Container, Row, Col
} from 'reactstrap';
import MenuNew from '../MenuNew';
//import NavbarDrop from '../HomePageNew/NavbarDrop';
import Footer from '../HomePageNew/Footer';

import queryString from 'query-string';
import axios from 'axios';
import '../../assets/css/timeline.css';


class Page extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            details: '',
            showData:false,
            sendConfirm: false,
            status:'',
            holder: '',            
            stateList:[]
        };

        this.styles = {
            fieldset: {
                border: '1px solid #f5aa00',
                padding: 10,
                marginTop: 15,
                paddingBottom: 25,
                borderRadius: 5
            },
            legend: {
                width: 'auto',
                fontSize: 20,
                position: 'relative',
                marginLeft: 15,
                padding: '0 5px'
            },
            input: {
                width: '100%'
            },
            label: {
                margin: 0
            },
            col: {
                marginTop: 0,
                paddingBottom: 0
            },
            alignCenter:{
                textAlign:'center'
            }
        };

        this.setShowContent = this.setShowContent.bind(this);
    }

    componentDidMount() {
        this.getDetails();
        //this.getUfs();
    }

    setShowContent(showData, status){
        this.setState({ status: status });
        this.setState({ showData: showData });
    }

    getDetails() {

        let param = queryString.parse(window.location.search);
        let all = this;
        if (param.q != undefined && param.q != '') 
        {   
                axios.get(urlBase.loopBack + 'Inclusions/' + param.q)
                .then((result) => {
                                                         
                    switch (result.data.status) {
                        case "CANCELADO":                                
                                this.setState({ sendConfirm: false });
                            break;                    
                        case "PAGAMENTO PENDENTE":                            
                            this.confirmProposal(param.q, result.data.confirmation);
                            break;                    
                        case "ATIVO":
                                this.setState({ sendConfirm: false });
                            break;                            
                    }
                    
                    this.setState({ status: result.data.status});
                    this.setState({ showData: true });                    
                    this.setShowContent(true, result.data.status);

                })
                .catch(function (erro) {  
                    console.log(erro);
                    all.setShowContent(true,'ERRO');
                });
                
        }
    }

    confirmProposal(id,status) {

        if(status){
            this.setState({ showData:true});
            this.setState({ status: 'CONFIRMADO' });
        }else{
            
            let url = urlBase.loopBack + 'Inclusions/confirmInclusion';
            let dataPost = {
                id: id
            };

            axios.post(url, dataPost)
                .then((result) => {
                    console.log(result);
                    this.setState({ showData: true });
                    this.setState({ status: 'CONFIRMADO' });
                })
                .catch(function () {
                    //alert(erro);
                });
        }

        
    }

    searchHolder(cpf) {

        let url = urlBase.loopBack + 'APIS4s/Associados';
        let dataPost = {
            cpf: cpf
        };

        axios.post(url, dataPost)
        .then((result) => {
            this.setState({ holder: result.data[0] });
            // this.getCity(result.data[0].Municipio);                
        })
        .catch(function () {
            //alert(erro);
        });

    }

    render() {
        return (
            <div>
                <MenuNew />

                <Container id="wallet_slip">
                    <div >
                        <Row style={{ marginRight: 0 }}>
                            <Col style={{ marginTop: 90 }} xs="12" sm="12" md="2" lg="2" xl="2">{''}</Col>

                            <Col id="wallet_slip_app_text" xs="12" sm="12" md="8" lg="8" xl="8">
                                <h1>INCLUSÃO DE DEPENDENTE</h1>
                            </Col>

                            <Col style={{ marginTop: 60 }} xs="12" sm="12" md="2" lg="2" xl="2">{''}</Col>
                        </Row>
                    </div>
                </Container>

                {(this.state.showData && this.state.status!=="ERRO" ?(
                    <Container style={{ marginTop: -40 }} >
                        <Row style={{ marginRight: 0 }}>
                            <Col style={{margiLeft: 20 }} xs="12" sm="12" md="12" lg="12" xl="12">                                                                
                                <div style={{ textAlign: 'center', marginTop: 70, color: '#505050' }}>
                                    <h1 style={{ fontFamily: 'RubikBold', fontSize: 30 }}>Inclusão confirmada com sucesso.</h1>
                                    <p>Parabéns, sua proposta foi aprovada com sucesso!</p>
                                </div>
                            </Col>
                        </Row>
                    </Container>

                ):(''))}

                {(!this.state.showData? (
                    <p className="text_footer text_red">Aguarde....</p>
                ) : (''))}

                {(this.state.status === "ERRO" ? (
                    <Container style={{ marginTop: -40 }} >
                        <Row style={{ marginRight: 0 }}>
                            <Col style={{ margiLeft: 20 }} xs="12" sm="12" md="12" lg="12" xl="12">
                                <div style={{ textAlign: 'center', marginTop: 70, color: '#505050' }}>
                                    <h1 style={{ fontFamily: 'RubikBold', fontSize: 30 }}>Proposta não localizada</h1>
                                    <p>Erros acontecem... Não conseguimos localizar sua proposta!</p>
                                </div>
                            </Col>
                        </Row>
                    </Container>

                ) : (''))}

                <Footer />
            </div>

        );
    }
}
export default Page;



/** WEBPACK FOOTER **
 ** ./src/components/Inclusion/Page.js
 **/